import { Gauge, Newspaper, Users2, HeartPulse, CalendarDays, Sparkles, LayoutGrid } from "lucide-react";
// V3 shared section header: soft teal icon tile + bold title + one-line subtitle.
export const OpsSectionHead = ({ icon: Icon, title, sub, right, testid }) => (
  <div className="flex items-center justify-between flex-wrap gap-3" data-testid={testid}>
    <div className="flex items-center gap-3 min-w-0">
      {Icon && (
        <span className="w-9 h-9 rounded-[10px] grid place-items-center shrink-0" style={{ background: "#E6F6F3" }}>
          <Icon className="h-[18px] w-[18px]" style={{ color: "#1F8A7C" }} strokeWidth={2.25} />
        </span>
      )}
      <div className="min-w-0">
        <h2 className="text-lg font-extrabold text-gray-900 leading-tight" style={{ fontFamily: "Manrope", letterSpacing: "-0.01em" }}>{title}</h2>
        {sub && <div className="text-xs sm:text-sm text-gray-500">{sub}</div>}
      </div>
    </div>
    {right && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{right}</div>}
  </div>
);

const PILL_ICONS = {
  "Today at a Glance": Gauge, "Monday Morning Briefing": Newspaper, "Staffing Planner": Users2, "Business Pulse": HeartPulse,
  "Daycare This Week": CalendarDays, "Outlook & Automation": Sparkles,
};

// V3 replacement for the old navy "pill" section titles: teal icon tile + bold title.
export const V3Pill = ({ children, icon }) => {
  const Icon = icon || PILL_ICONS[typeof children === "string" ? children : ""] || LayoutGrid;
  return (
    <span className="inline-flex items-center gap-2.5">
      <span className="w-8 h-8 rounded-[10px] grid place-items-center shrink-0" style={{ background: "#E6F6F3" }}><Icon className="h-4 w-4" style={{ color: "#1F8A7C" }} strokeWidth={2.25} /></span>
      <span className="text-lg font-extrabold text-gray-900" style={{ fontFamily: "Manrope", letterSpacing: "-0.01em" }}>{children}</span>
    </span>
  );
};
